import React from "react";
import "./AboutCurriculum.css";

function AboutCuriculum({ count }) {
  const tabs = [
    {
      year: "Year 1",
      module: "ChildVision1 (CV1)",
      info: "successful Grade 10 applicants",
    },
    {
      year: "Year 2",
      module: "ChildVision2 (CV2)",
      info: "successful CV1 graduate applicants",
    },
    {
      year: "Year 3",
      module: "ChildVision Post Graduate (CVPG)",
      info: "successful CV2 graduate applicants",
    },
  ];

  const subject = [
    [
      "OVC centre leadership Level 1",
      "Work with families and communities to support Early Childhood Development",
      "Provide care for babies, toddlers and young children ",
      "Demonstrate knowledge and understanding of the development of babies, toddlers and young children",
      "Prepare Early Childhood Development programmes with support",
      "Prepare resources and set up the environment to support the development of babies, toddlers and young children",
      "Facilitate the holistic development of babies, toddlers and young children",
      "Design activities to support the development of babies, toddlers and young children",
      "Facilitate community Bible study",
      "Facilitate children Bible education",
      "Observe and report on child development Level 1",
      "Demonstrate knowledge and understanding of using self-help saving groups to save, borrow and lend money for financial growth",
      "Demonstrate knowledge and understanding of food production for improved nutrition and income",
      <i style={{ marginLeft: 20 }}>Organic vegetables</i>,
      <i style={{ marginLeft: 20 }}>Free - range eggs</i>,
      <i style={{ marginLeft: 20 }}>Free - range chicken meat</i>,
      <i style={{ marginLeft: 20 }}>Fruit</i>,
      "Demonstrate knowledge and understanding of basic Income generation from micro-businesses",
      "Demonstrate knowledge and understanding of business planning for financial growth",
      "Demonstrate knowledge and understanding of basic practical financial management for financial growth",
      "Demonstrate knowledge and understanding of the principles required for sustainable OVC centre management Electives",
      <i style={{ marginLeft: 20 }}> Maths</i>,
      <i style={{ marginLeft: 20 }}> English</i>,
      <i
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          fontWeight: 600,
        }}
      >
        end
      </i>,
    ],
    [
      "OVC centre leadership Level 2",
      "Demonstrate knowledge and understanding of facilitating learning",
      "Apply workplace communication skills",
      "Demonstrate knowledge and understanding of using computers and cell phones for centre management and communications",
      "Present information in a public setting",
      "Demonstrate knowledge and understanding of first aid",
      "Mediate active learning in ECD programmes ",
      "Promote healthy development in Early Childhood programmes",
      "Develop and manage the ECD learning programme",
      "Facilitate a Numeracy Learning Programme in the Reception Year ",
      "Facilitate a Literacy Learning Programme in the Reception Year ",
      "Facilitate a Life Skills Learning Programme in the Reception Year",
      "Demonstrate knowledge and understanding of Biblical Theology",
      "Observe and report on child development Level 2",
      "Use self-help saving groups to work with, help and involve families in the centres and contribute to sustainable centre management",
      "Use food production to work with, help and involve families in the centres and contribute to sustainable centre management",
      "Use income generation to work with, help and involve families in the centres and contribute to sustainable centre management",
      "Use business planning to work with, help and involve families in the centres and contribute to sustainable centre management",
      "Use basic practical financial management to work with, help and involve families in the centres and contribute to sustainable centre management",
      <i
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          fontWeight: 600,
        }}
      >
        end
      </i>,
    ],
    [
      " Mini dissertation with specific emphasis on centre sustainability",
      "OVC centre leadership Level 3",
      "Demonstrate knowledge and understanding of leading centres in transformation",
      "Observe and report on child development Level 3",
      "Observe and report on family development Level 1",
      "Establish and manage 5 self-help saving groups from the centre",
      "Establish and manage income generation activities with the members of the self-help groups",
      "Establish and manage business planning with the members of the self-help groups",
      "Establish and manage practical financial management with the members of the self-help groups",
      "Establish and manage food production with the members of the self-help groups",
      "Training of CV1 leaders ",
      <i
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          fontWeight: 600,
        }}
      >
        end
      </i>,
    ],
  ];

  const subjectList = () => {
    return subject[count].map((el, i) => {
      return (
        <li key={i} className="Subject__List">
          {el}
        </li>
      );
      // console.log(el);
    });
  };

  const tabsTitle = () => {
    return tabs.map((el, i) => {
      if (count === i) {
        return (
          <div key={el.year} className="navcurriculum__bottom">
            <h3 id="curriculum__name">{el.module}</h3>
            <p id="curriculum__info">{el.info}</p>
          </div>
        );
      }
    });
  };

  // const translator = () => {
  //   return tabs.map((el, i) => {
  //     return (
  //       <>
  //         {count === i ? (
  //           <div
  //             onClick={() => setCount(i)}
  //             key={el.year}
  //             id="Year_1"
  //             className="Tab"
  //             style={{
  //               backgroundColor: "white",
  //               boxShadow: "1px 1px 5px rgba(0,0,0,0.6)",
  //             }}
  //           >
  //             <FaHourglassStart color="black" size={25} />
  //             <p style={{ color: "black" }}>{el.year}</p>
  //           </div>
  //         ) : (
  //           <div
  //             onClick={() => setCount(i)}
  //             key={el.year}
  //             id="Year_1"
  //             className="Tab"
  //           >
  //             <FaHourglassStart size={25} />
  //             <p>{el.year}</p>
  //           </div>
  //         )}
  //       </>
  //     );
  //   });
  // };

  return (
    <div className="curriculum__display">
      <h2 id="curriculum__Title" className="curriculum__Title">
        Our Curriculum
      </h2>
      <div className="about__curriculum_emptycontainer">{tabsTitle()}</div>

      <div id="curriculum_tabbed" className="curriculum_tabbed">
        <div className="curriculum__tab__Body">
          <div className="curriculum__tab__Body-Content">{subjectList()}</div>
        </div>
      </div>
    </div>
  );
}

export default AboutCuriculum;
